// extracted by mini-css-extract-plugin
export var banner = "offer-module--banner--0ONmp";
export var bannerColumn = "offer-module--banner-column--mHc9d";
export var bannerTitle = "offer-module--banner-title--78hgb";
export var content = "offer-module--content--VWptg";
export var footer = "offer-module--footer--43E6J";
export var header = "offer-module--header--BTrBe";
export var list = "offer-module--list--vrUR0";
export var price = "offer-module--price--hTxJJ";
export var priceMeta = "offer-module--price-meta--eocBb";
export var priceValue = "offer-module--price-value--zmhim";
export var renew = "offer-module--renew--tgokk";
export var root = "offer-module--root--w94tp";
export var subtitle = "offer-module--subtitle--Y+Pj7";
export var title = "offer-module--title--9JODC";